// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunk-" + chunkId + "-" + {"895":"c55eb3b3eff46177895d","3827":"5f3f1eca76c8e78702b8","5692":"0755ac83032c1dde035b","7113":"e07a8b698a76ea993575"}[chunkId] + ".bundle.css";
};